import { TThunkAction } from '../../../types/thunk';
import { publishOffer } from '../../../redux/reducers';
import { EPaymentInitSource, EPaymentWidgetResultStatus } from '../../../types/microfrontends/paymentWidget';
import { selectPaymentDeltaAmount } from '../../../selectors/checkoutInfo';
import { EPaymentCheckType, EPaymentStatus } from '../../../types/microfrontends/servicePickerWidget';

export const makePaymentBeforePublishThunk =
  (): TThunkAction =>
  async (dispatch, getState, { paymentWidgetMicrofrontend, servicePickerWidgetMicrofrontend }) => {
    const state = getState();
    const amount = selectPaymentDeltaAmount(state);

    const result = await paymentWidgetMicrofrontend!.openDepositModal({
      amount,
      paymentInitSource: EPaymentInitSource.AddFormDeposit,
    });

    if (result.status === EPaymentWidgetResultStatus.Success) {
      const paymentStatus = await servicePickerWidgetMicrofrontend?.checkPaymentStatus(
        result.paymentId,
        result.provider,
        EPaymentCheckType.Balance,
      );

      if (paymentStatus === EPaymentStatus.Succeeded) {
        dispatch(publishOffer({ isPremoderationSkip: false }));
      }
    }
  };
